export default __webpack_public_path__ + "static/media/Default_Product_Icon.8dd27240.png";